/**
 * Copyright (c) 2025-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// N.B! AUTOGENERATED FILE. DO NOT EDIT
// Source: RemixIcon
// License: Apache License 2.0
import type { JSX } from "react";
import { Icon, type Props } from "../Icon";
export const PlayLine = (props: Props): JSX.Element => (
  <Icon fill="currentColor" viewBox="0 0 24 24" {...props}>
    <path d="M16.4 12 10 7.74v8.52zm2.98.42-10.6 7.06a.5.5 0 0 1-.78-.41V4.93a.5.5 0 0 1 .78-.41l10.6 7.06a.5.5 0 0 1 0 .84" />
  </Icon>
);
